/**
 * Pure helpers for Settings billing + tenant support (plan 4 R11).
 */

/**
 * Plan label from /auth/me - billing APIs do not exist yet.
 * @param {object|null|undefined} me
 */
export function planLabel(me) {
  const raw = (me && (me.tenant_plan || me.plan)) || 'free';
  const text = String(raw).trim() || 'free';
  return text.charAt(0).toUpperCase() + text.slice(1);
}

/**
 * Seat / usage lines available without a billing API.
 * @param {object|null|undefined} me
 * @param {{ userCount?: number|null }} [opts]
 */
export function billingSummary(me, opts) {
  const plan = planLabel(me);
  const seats = opts && opts.userCount != null ? Number(opts.userCount) : null;
  const lines = [
    { label: 'Plan', value: plan },
    {
      label: 'Seats',
      value: Number.isFinite(seats) && seats >= 0 ? String(seats) : '-',
    },
    { label: 'Included AI usage', value: '- (beta)' },
    { label: 'Your own API keys', value: 'Billed by the provider' },
  ];
  return { plan, lines };
}

/**
 * @param {{ slot_label?: string, slot_time?: string }|null|undefined} session
 */
export function sessionWhen(session) {
  if (!session) return '';
  const label = String(session.slot_label || '').trim();
  if (label) return label;
  const at = session.slot_time ? new Date(session.slot_time) : null;
  if (!at || !Number.isFinite(at.getTime())) return '';
  const date = at.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  const time = at.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', hour12: true });
  return `${date} at ${time}`;
}

/**
 * @param {Array<{ role?: string, text?: string, created_at?: string }>} messages
 * @param {number} [limit]
 */
export function recentSupportMessages(messages, limit = 8) {
  const rows = Array.isArray(messages) ? messages.slice() : [];
  const n = Math.max(1, limit);
  return rows.slice(Math.max(0, rows.length - n));
}

/**
 * Guard before POST /support/message - never send secrets.
 * @param {string} text
 */
export function supportMessageCheck(text) {
  const message = String(text || '').trim();
  if (!message) return { ok: false, error: 'Write a message first.' };
  if (looksLikeCredential(message)) {
    return {
      ok: false,
      error: 'That looks like a credential. It was not sent - paste it on the connector form.',
    };
  }
  return { ok: true, message };
}

function looksLikeCredential(text) {
  return /-----BEGIN |ghp_|github_pat_|xox[baprs]-|sk_live_|sk-[A-Za-z0-9_-]{16,}|AIza[0-9A-Za-z_-]{20,}/.test(
    String(text || ''),
  );
}

/** @param {string|null|undefined} email */
export function mailtoSupport(email) {
  const addr = String(email || '').trim() || 'hello@bonnieos.com';
  return `mailto:${addr}`;
}
